@import 'styles/mixins';
@import 'styles/variables';

.tooltipContent {
  background: $navy-90;
  color: $white;
  display: flex;
  padding: 16px;
  width: 328px;
  border-radius: 8px;
  @include ui-sm-text;

  & svg {
    fill: $white;
    margin-right: 8px;
  }
}

.tooltipHeader {
  @include ui-md-bold;
  margin-bottom: 8px;
}
